import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type Company = {
  id: string
  name: string
  apiName: string // Add API name for backend compatibility
}

export const companies: Company[] = [
  { id: 'falcon', name: 'Falcon Holdings LLC', apiName: 'Falcon Holdings LLC' },
  { id: 'piccadilly', name: 'Piccadilly', apiName: 'Piccadilly' },
  { id: 'kw', name: 'K&W Cafeterias', apiName: 'K&W Cafeterias' },
  { id: 'churchs', name: "Church's Chicken", apiName: "Church's Chicken" },
  { id: 'nbrg', name: 'NBRG', apiName: 'NB Restaurant Group' }, // Map NBRG to "NB Restaurant Group" for API
]

interface CompanyState {
  selectedCompany: Company
  setSelectedCompany: (company: Company) => void
}

export const useCompanyStore = create<CompanyState>()(
  persist(
    (set) => ({
      selectedCompany: companies[0],
      setSelectedCompany: (company: Company) => set({ selectedCompany: company }),
    }),
    {
      name: 'company-storage',
    }
  )
)